<template>
  <div
    class="w-full rounded-lg bg-background px-6 py-3 shadow"
  >
    <div
      class="flex flex-row items-center justify-start space-x-2"
    >
      <div class="flex flex-col justify-center">
        <p
          class="line-clamp-1 w-9 text-left text-sm font-semibold"
        >
          {{ formatToTime(order.createdAt) }}
        </p>
      </div>

      <div class="flex flex-1 justify-start">
        <span
          class="mr-2 line-clamp-1 text-left text-xs text-background-fg/70"
        >
          {{
            [numberOfItemsString, order.note]
              .filter(Boolean)
              .join(" - ")
          }}
        </span>
      </div>

      <p
        class="min-w-12 text-right font-semibold text-background-fg"
      >
        {{
          formatToMerchantCurrencyString(order.totalCost)
        }}
      </p>
      <PaymentDetailChip
        v-if="
          !tenant.isCashiersEnabled && order.invoice?.paidBy
        "
        :payment="order.invoice.paidBy"
      />
    </div>

    <!-- Negative left margin (-ml-1.5) aligns the cashier pill with the order time text for visual consistency -->
    <div
      v-if="tenant.isCashiersEnabled"
      class="-ml-1.5 mt-0.5 flex flex-row items-center justify-between"
    >
      <span
        class="inline-block rounded-full bg-background-fg/25 px-2 py-px text-xs text-white"
        :style="{
          backgroundColor:
            cashier?.color ?? 'rgb(var(--color-cool-grey))',
        }"
      >
        {{ cashier?.username || "No Cashier" }}
      </span>

      <PaymentDetailChip
        v-if="order.invoice?.paidBy"
        :payment="order.invoice.paidBy"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ListOrdersResponseItem } from "@/services/orders/listOrders"
import type { TransactionsFeedOrder } from "@/services/orders/listTransactionsFeed"

const { getById: getCashierById } = useCashiers()
const { formatToMerchantCurrencyString } = useCurrency()
const { tenant } = useTenant()
const props = defineProps<{
  order: ListOrdersResponseItem | TransactionsFeedOrder
}>()

const cashier = computed(
  () => getCashierById(props.order.cashierId).value
)

const numberOfItemsString = computed(() => {
  if (
    !tenant.isProductsEnabled &&
    props.order.numberOfItems === 1
  ) {
    return ""
  } else if (props.order.numberOfItems === 0) {
    return ""
  } else if (props.order.numberOfItems === 1) {
    return "1 item"
  } else {
    return `${props.order.numberOfItems} items`
  }
})
</script>
